import React, { useState } from "react"
import i18n from "../../../../services/i18n"
import { Row, Col, Select, Button, Space, Typography, Tag, message } from "antd"
import { Play, Volume2, CheckCircle } from "react-feather"
import { SOUND_PRESETS, playNotificationSound } from "../../../../utils/notificationSounds"

export default function AudioChange() {
  const [selectedSound, setSelectedSound] = useState<number>(() => {
    return parseInt(localStorage.getItem("crm_selected_sound") || "0", 10)
  })

  const handleChange = (val: number) => {
    setSelectedSound(val)
    localStorage.setItem("crm_selected_sound", val.toString())
    playNotificationSound(val)
    message.success(i18n.t("msgAudioUpdated"))
  }

  const handleTestPlay = () => {
    playNotificationSound(selectedSound)
  }

  const currentPreset = SOUND_PRESETS.find((s) => s.id === selectedSound) || SOUND_PRESETS[0]

  return (
    <div style={{ padding: "8px 0" }}>
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} md={14}>
          <Space direction="vertical" style={{ width: "100%" }} size={8}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography.Text strong style={{ fontSize: 13 }}>
                Bildirishnoma ovozini tanlang (10 ta zamonaviy audio):
              </Typography.Text>
              <Tag color="blue">{currentPreset.category}</Tag>
            </div>
            <Select
              style={{ width: "100%" }}
              size="large"
              value={selectedSound}
              onChange={handleChange}
              options={SOUND_PRESETS.map((preset) => ({
                label: `${preset.id + 1}. ${preset.name} - ${preset.description}`,
                value: preset.id,
              }))}
            />
          </Space>
        </Col>

        <Col xs={24} md={10} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
          <Space>
            <Button
              type="primary"
              size="large"
              icon={<Play size={16} style={{ marginRight: 6 }} />}
              onClick={handleTestPlay}
              style={{
                background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
                borderRadius: 8,
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              Tinglash (Play)
            </Button>
          </Space>
        </Col>
      </Row>
    </div>
  )
}
